<template>
    <div class="service-details ptb-100">
        <div class="container">
            <div class="service-details-content">
                <h3 data-aos="fade-up" data-aos-once="true">Ihre Webseite - Ihr digitales Aushängeschild</h3>

                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">In der heutigen digitalen Welt ist eine professionelle Webseite unverzichtbar. Sie ist oft der erste Kontaktpunkt zwischen Ihnen und potenziellen Kunden. Wir entwickeln Webseiten, die nicht nur gut aussehen, sondern auch Ergebnisse liefern.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-once="true" data-aos-delay="0">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-file'></i>
                            </div>
                            <h3>Landingpages</h3>
                            <p>Fokussierte Seiten für Kampagnen und Produktvorstellungen. Optimiert für Conversions und messbare Ergebnisse.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-once="true" data-aos-delay="100">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-building-house'></i>
                            </div>
                            <h3>Unternehmenswebseiten</h3>
                            <p>Professionelle Online-Präsenz für Ihr Unternehmen. Mehrere Seiten, Kontaktformulare und alle wichtigen Informationen.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-once="true" data-aos-delay="200">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-cart'></i>
                            </div>
                            <h3>E-Commerce-Lösungen</h3>
                            <p>Individuelle Online-Shops nach Ihren Anforderungen. Produktverwaltung, Zahlungsabwicklung und Versandintegration - maßgeschneidert.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-once="true" data-aos-delay="300">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-cog'></i>
                            </div>
                            <h3>Webanwendungen</h3>
                            <p>Interaktive Tools, Dashboards und Kundenportale. Individuelle Lösungen für Ihre Geschäftsprozesse.</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Der Entwicklungsprozess</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Jedes Projekt beginnt mit einem kostenlosen Erstgespräch. Wir besprechen Ihre Anforderungen, Zielgruppe und Ziele. Danach erhalten Sie ein individuelles Angebot mit klarer Preisstruktur - ohne versteckte Kosten.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-3 col-md-6 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="0">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-conversation'></i>
                            <h3>Erstgespräch</h3>
                            <p>Schritt 1</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="100">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-palette'></i>
                            <h3>Konzept & Design</h3>
                            <p>Schritt 2</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="200">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-code-alt'></i>
                            <h3>Entwicklung</h3>
                            <p>Schritt 3</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6" data-aos="zoom-in" data-aos-once="true" data-aos-delay="300">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-rocket'></i>
                            <h3>Launch</h3>
                            <p>Schritt 4</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Technologien, die Ergebnisse liefern</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Wir setzen auf moderne, bewährte Technologien. Je nach Projektanforderung kommen zum Einsatz:</p>

                <ul class="features-list" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <li><i class='bx bx-check'></i> <strong>Vue.js / React</strong> - Für dynamische, schnelle Webanwendungen</li>
                    <li><i class='bx bx-check'></i> <strong>TypeScript</strong> - Typsichere Entwicklung für wartbaren Code</li>
                    <li><i class='bx bx-check'></i> <strong>Node.js / GoLang / PostgreSQL</strong> - Robuste Backend-Lösungen und Datenbanken</li>
                    <li><i class='bx bx-check'></i> <strong>Responsive Design</strong> - Perfekte Darstellung auf Desktop, Tablet und Smartphone</li>
                    <li><i class='bx bx-check'></i> <strong>SEO-Grundoptimierung</strong> - Damit Google Sie findet</li>
                </ul>

                <h4 data-aos="fade-up" data-aos-once="true">Warum mit mir arbeiten?</h4>
                <p data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Als Einzelunternehmer bin ich Ihr direkter Ansprechpartner. Keine Agentur-Strukturen, keine Warteschleifen, keine anonymen Tickets. Sie erreichen mich persönlich und ich kümmere mich um Ihr Projekt von Anfang bis Ende.</p>

                <div class="pricing-box mt-5" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                    <div class="single-pricing-table">
                        <div class="pricing-header">
                            <h3>Webseiten-Paket</h3>
                        </div>

                        <div class="price">
                            <span class="price-text">Nach Vereinbarung</span>
                        </div>

                        <p class="pricing-description">Lassen Sie uns in einem kostenlosen Erstgespräch besprechen, wie ich Ihnen helfen kann.</p>

                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Responsive Design</li>
                            <li><i class='bx bxs-badge-check'></i> SEO-Grundoptimierung</li>
                            <li><i class='bx bxs-badge-check'></i> Performance-Optimierung</li>
                            <li><i class='bx bxs-badge-check'></i> SSL-Verschlüsselung</li>
                            <li><i class='bx bxs-badge-check'></i> Kontaktformular</li>
                            <li><i class='bx bxs-badge-check'></i> Persönliche Betreuung</li>
                        </ul>

                        <div class="btn-box">
                            <router-link to="/contact" class="default-btn">
                                <i class='bx bxs-paper-plane'></i>
                                Jetzt Kontakt aufnehmen
                                <span></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WebentwicklungDetails'
}
</script>

<style scoped>
.pricing-box {
    max-width: 450px;
    margin: 0 auto;
}

.pricing-box .single-pricing-table {
    background: #ffffff;
    border-radius: 10px;
    padding: 40px 30px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.pricing-box .pricing-header h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #080a3c;
}

.pricing-box .price {
    margin-bottom: 25px;
}

.pricing-box .price-text {
    font-size: 28px;
    font-weight: 700;
    color: #010215;
}

.pricing-box .pricing-description {
    color: #4a6f8a;
    margin-bottom: 25px;
    font-size: 15px;
}

.pricing-box .pricing-features {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
    text-align: left;
}

.pricing-box .pricing-features li {
    padding: 12px 0 !important;
    padding-left: 0 !important;
    border-bottom: 1px solid #eee;
    color: #4a6f8a;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 12px;
    position: static !important;
}

.pricing-box .pricing-features li:last-child {
    border-bottom: none;
}

.pricing-box .pricing-features li i {
    color: #010215;
    font-size: 18px;
    flex-shrink: 0;
    position: static !important;
}

.pricing-box .btn-box {
    text-align: center;
}
</style>
